import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['image', 'placeholder']

  showPlaceholder() {
    this.imageTarget.classList.add('hidden')
    this.placeholderTarget.classList.remove('hidden')
  }
}
